import {
  COLLECTIONS_PLAN_TYPE,
  DEFAULT_PLAN_TYPE,
  DELIVERY_PLAN_TYPES,
  OVERRIDES_PLAN_TYPE,
} from "../consts/planTypes";

import { getOverridesConflictsAreas } from "./overrides";

export const isPlanTypeValid = ({
  isValid,
  planType = DEFAULT_PLAN_TYPE,
  driverlessRoutes = {
    B: [],
    C: [],
    D: [],
    I: [],
    O: [],
    L: [],
    R: [],
    S: [],
  },
  unallocatedAreas = [],
  singleWaveAreas = [],
  overrideAreas = {
    outer: [],
    sector: [],
    postcode: [],
  },
}) => {
  let hasDriverlessRoutes = false;
  driverlessRoutes = Object.keys(driverlessRoutes).reduce((acc, type) => {
    acc[type] = driverlessRoutes[type].map(({ routeCode }) => routeCode);
    if (acc[type].length) hasDriverlessRoutes = true;
    return acc;
  }, {});

  if (
    [
      ...DELIVERY_PLAN_TYPES.filter((type) => type !== DEFAULT_PLAN_TYPE),
      COLLECTIONS_PLAN_TYPE,
    ].includes(planType)
  )
    return {
      isValid,
      hasDriverlessRoutes,
      driverlessRoutes,
    };
  else if (planType === OVERRIDES_PLAN_TYPE)
    return {
      isValid,
      hasDriverlessRoutes,
      driverlessRoutes,
      overridesConflictsPostcodes: getOverridesConflictsAreas({
        overrideAreas,
      }),
    };
  else
    return {
      isValid: !unallocatedAreas.length,
      hasDriverlessRoutes,
      driverlessRoutes,
      unallocatedPostcodes: unallocatedAreas.map(
        ({ outer, sector, postcode }) => postcode || sector || outer
      ),
      singleWavePostcodes: singleWaveAreas.map(
        ({ outer, sector, postcode }) => postcode || sector || outer
      ),
    };
};
